const LoadingNumberItem = (props: { load?: any }) => {
  const item = props.load

  if (item?.preferred_source?.supplier && !item?.loading_number)
    return (
      <span style={{ color: "orange" }}>
        Assign loading # to keep supplier info
      </span>
    )
  return (
    <div style={{ display: "grid" }}>
      <span>
        {item?.loading_number?.loading_number ?? item?.loading_number}
      </span>
      <span style={{ fontSize: 13 }}>
        {[
          item?.loading_number?.wholesaler ?? item?.wholesaler,
          item?.loading_number?.description ?? item?.description,
        ]
          .filter((x) => x)
          .join(" | ")}
      </span>
    </div>
  )
}

export default LoadingNumberItem
